import { track } from '@amplitude/analytics-browser'

class AnalyticsContext {
  constructor() {}

  trackEvent(eventName: string, eventProperties: Record<string, any> = {}) {
    try {
      track(eventName, eventProperties)
    } catch (error) {
      console.error('Amplitude tracking error:', error)
    }
  }
}

export const analyticsContext = new AnalyticsContext()
